import { render, staticRenderFns } from "./CompetitionRuleConfig.vue?vue&type=template&id=ff4dda74&scoped=true"
import script from "./CompetitionRuleConfig.vue?vue&type=script&lang=js"
export * from "./CompetitionRuleConfig.vue?vue&type=script&lang=js"
import style0 from "./CompetitionRuleConfig.vue?vue&type=style&index=0&id=ff4dda74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff4dda74",
  null
  
)

export default component.exports